import { LoadingState, Text } from '@cinesend/ui-kit'
import AppDialog from '../../components/app_dialog'
import { humanFileSize } from '../../helpers/human_file_size'
import { convertToWithTimezone } from '../../helpers/convert_date'
import { useQuery } from '@tanstack/react-query'
import { CheckCircle } from '@phosphor-icons/react'
import { Link, useParams } from 'react-router-dom'

const assetPath = ({ asset, airlineID, cycleID }) => {
  if (!asset?.id || !airlineID || !cycleID) return null
  if (asset.asset_type === 'ad') {
    return `/airlines/${airlineID}/cycles/${cycleID}/ads/clips/${asset.id}`
  }
  if (!asset.route_value) return null
  return `/airlines/${airlineID}/cycles/${cycleID}/metadata/${asset.route_value}/${asset.id}`
}

const ImageModal = ({ image, onClose }) => {
  const { airlineID, cycleID } = useParams()
  const { data: imageData, isLoading } = useQuery([`/asset-images`, `/${image.id}`])
  const matchedAssetPath = assetPath({ asset: image?.asset, airlineID, cycleID })

  return (
    <AppDialog title={image.file_name} onClose={onClose}>
      {isLoading ? (
        <LoadingState className='justify-center' />
      ) : (
        <div className='flex flex-col space-y-4'>
          <img
            src={imageData?.asset_image?.signed_url}
            alt={image?.file_name}
            className='w-full max-h-96 object-contain'
          />
          <div className='space-y-1 border-t border-[color:var(--cs-color-border-default)] pt-4 text-left'>
            <Text as='p' variant='sm'>
              <Text as='span' variant='sm-medium'>
                File name:
              </Text>{' '}
              {image?.file_name}
            </Text>
            <Text as='p' variant='sm'>
              <Text as='span' variant='sm-medium'>
                File size:
              </Text>{' '}
              {humanFileSize(image?.size)}
            </Text>
            <Text as='p' variant='sm'>
              <Text as='span' variant='sm-medium'>
                Created at:
              </Text>{' '}
              {convertToWithTimezone(image?.created_at)}
            </Text>
          </div>
          {image.asset_id && image.field_id ? (
            <div className='border-t border-[color:var(--cs-color-border-default)] pt-4 text-left'>
              <div className='flex items-center gap-2'>
                <CheckCircle
                  size={20}
                  weight='fill'
                  className='shrink-0 text-[color:var(--cs-color-foreground-success)]'
                  aria-hidden='true'
                />
                <Text as='p' variant='sm-medium'>
                  Image matched successfully
                </Text>
              </div>
              <div className='mt-3 space-y-1'>
                <Text as='p' variant='sm'>
                  <Text as='span' variant='sm-medium'>
                    Asset:
                  </Text>{' '}
                  {matchedAssetPath ? (
                    <Link to={matchedAssetPath} className='hover:underline' onClick={onClose}>
                      {image?.asset?.title}
                    </Link>
                  ) : (
                    image?.asset?.title
                  )}
                </Text>
                <Text as='p' variant='sm'>
                  <Text as='span' variant='sm-medium'>
                    Field:
                  </Text>{' '}
                  {image?.field?.name}
                </Text>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </AppDialog>
  )
}

export default ImageModal
